import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface LogoutProps {
  redirectTo?: string;
}

function getParentDomain(url: string) {
  // Remove protocol (http:// or https://) and trailing slash
  const domain = url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').split('/')[0];

  // Split the domain into its subdomains
  const parts = domain.split('.');

  // If the domain has less than 3 parts, return the full domain
  if (parts.length <= 2) {
    return domain;
  }

  // Otherwise, return the last two parts (parent domain)
  return parts.slice(-2).join('.');
}

function clearAllData() {
  // Clear localStorage
  localStorage.clear();

  // Clear cookies
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;Domain=.${getParentDomain(
      window.location.origin
    )}`;
  }
}

const Logout: React.FC<LogoutProps> = ({ redirectTo }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  useEffect(() => {
    const _redirectTo = queryParams.get('redirect-to');
    clearAllData();
    if (redirectTo) {
      window.location.href = redirectTo;
    } else {
      window.location.href = _redirectTo;
    }
  }, []);

  return null;
};

export { Logout };
